var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Socialmedia/thumbs.up",
    clipPath: "url(#clip0_2255_4658)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5652 1.19551C7.68547 0.924892 7.95384 0.750488 8.24998 0.750488C9.04546 0.750488 9.80837 1.06649 10.3709 1.62898C10.9333 2.19147 11.2494 2.95438 11.2494 3.74986V6.00049H14.7412C15.0656 5.99749 15.3869 6.06472 15.683 6.1976C15.9805 6.33112 16.2454 6.52771 16.4594 6.77377C16.6733 7.01983 16.8312 7.30947 16.9221 7.62261C17.0131 7.93576 17.0348 8.26493 16.9859 8.58731L16.9857 8.58844L15.9509 15.3372C15.9509 15.3374 15.9509 15.3371 15.9509 15.3372C15.8695 15.8734 15.597 16.3626 15.1837 16.7138C14.7716 17.0642 14.247 17.2542 13.7063 17.2492H2.99998C2.40341 17.2492 1.83127 17.0122 1.40944 16.5904C0.987597 16.1686 0.75061 15.5964 0.75061 14.9999V9.74986C0.75061 9.15329 0.987597 8.58115 1.40944 8.15931C1.83127 7.73747 2.40341 7.50049 2.99998 7.50049H4.76299L7.5652 1.19551ZM5.99935 8.40889L8.70551 2.32004C8.93185 2.39215 9.14 2.51766 9.31109 2.68875C9.59251 2.97018 9.75061 3.35187 9.75061 3.74986V6.74986C9.75061 7.16373 10.0861 7.49923 10.5 7.49923H14.745L14.7535 7.49918C14.8623 7.49795 14.97 7.52039 15.0693 7.56494C15.1686 7.6095 15.257 7.6751 15.3284 7.75722C15.3998 7.83933 15.4525 7.93598 15.4828 8.04048C15.5131 8.1449 15.5204 8.25466 15.5041 8.36216C15.5041 8.36224 15.5041 8.36208 15.5041 8.36216L14.4691 15.1125C14.4419 15.2915 14.351 15.4546 14.2131 15.5719C14.0751 15.6891 13.8995 15.7526 13.7185 15.7505L5.99935 15.7505V8.40889ZM4.50061 15.7505V8.99923H2.99998C2.8009 8.99923 2.60998 9.07831 2.46921 9.21908C2.32844 9.35985 2.24935 9.55078 2.24935 9.74986V14.9999C2.24935 15.1989 2.32844 15.3899 2.46921 15.5306C2.60998 15.6714 2.8009 15.7505 2.99998 15.7505H4.50061Z",
    fill: "#231F20"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2255_4658"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/thumbs.up.e18722a1175dd59c65a4dfda4c86fec7.svg";
export { ForwardRef as ReactComponent };